import React from 'react'

const VisitReason = ({ formData, setFormData, setCurrentStep }) => {
  const visitTypes = [
    { id: 'sick', label: 'I am feeling sick' },
    { id: 'injury', label: 'Injury' },
    { id: 'checkup', label: 'General check up' },
    { id: 'followup', label: 'Follow-up visit' }
  ]

  const handleVisitTypeSelect = (visitType) => {
    setFormData({ ...formData, visitType })
    if (visitType === 'checkup' || visitType === 'followup') {
      setCurrentStep(4) // Skip to basic info step
    } else {
      setCurrentStep(3) // Go to symptoms/injury step
    }
  }

  return (
    <div className='step-container'>
      <h2>
        Hello {formData.patientRecord.firstName} {formData.patientRecord.lastName}
      </h2>
      <p>Please select the reason for your visit today</p>
      <div className='visit-types'>
        {visitTypes.map((type) => (
          <button key={type.id} onClick={() => handleVisitTypeSelect(type.id)} className='visit-type-btn'>
            {type.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default VisitReason
